import { Wheather } from "@/domains/hud/constants/global";
import { characterSelector, useHudStore, wheatherSelector } from "@/domains/hud/store";
import HudMap from "@/domains/hud/components/HudMap";

export default function HudMapContainer() {
  const character = useHudStore(characterSelector);
  const wheather = useHudStore(wheatherSelector);

  return (
    <HudMap
      isGreenZone={Boolean(character?.isInGreenZone)}
      wheatherState={wheather?.state || Wheather.CLEAR}
      wheatherDegree={wheather?.degree || 28}
    />
  );
}
